import { render, staticRenderFns } from "./MainAccountSidebar.vue?vue&type=template&id=0682d452&scoped=true"
import script from "./MainAccountSidebar.vue?vue&type=script&lang=js"
export * from "./MainAccountSidebar.vue?vue&type=script&lang=js"
import style0 from "./MainAccountSidebar.vue?vue&type=style&index=0&id=0682d452&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0682d452",
  null
  
)

export default component.exports